export default {"src":"/_next/static/media/trust-pilot-micro.ab5ebbfc.svg","height":36,"width":433,"blurWidth":0,"blurHeight":0};